import request from "../utils/request";
import { ParamsProps, ReturnType } from "./types";

const getByKey = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `general-settings/key/${args?.id}`,
      method: "get",
      authorization: false,
      config: {
        showErr: args?.showErr ?? true,
        store: {
          action: "set",
          key: args?.state,
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    if (args?.showErr === false) return null;
    throw new Error(err?.message || "An error occurred");
  }
};

const getByGroup = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `general-settings/group/${args?.id}`,
      method: "get",
      authorization: true,
      config: {
        showErr: args?.showErr ?? true,
        store: {
          action: "set",
          key: args?.state,
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    if (args?.showErr === false) return null;
    throw new Error(err?.message || "An error occurred");
  }
};

const create = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `general-settings`,
      method: "post",
      data: args?.data,
      authorization: true,
      config: {
        showErr: args?.showErr ?? true,
        store: {
          action: "set",
          key: args?.state,
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err?.message || "An error occurred");
  }
};

const update = async (args: ParamsProps) => {
  try {
    if (!args?.id) {
      throw new Error("ID is required for updating general settings");
    }
    const config: ReturnType = {
      url: `general-settings/${args?.id}`,
      method: "patch",
      data: args?.data,
      authorization: true,
      config: {
        showErr: args?.showErr ?? true,
        store: {
          action: "update",
          key: args?.state,
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err?.message || "An error occurred");
  }
};

const remove = async (args: ParamsProps) => {
  try {
    if (!args?.id) {
      throw new Error("ID is required for deleting general settings");
    }
    const config: ReturnType = {
      url: `general-settings/${args?.id}`,
      method: "delete",
      authorization: true,
      config: {
        showErr: args?.showErr ?? true,
        successMsg: "Deleted Successfully",
        store: {
          action: "remove",
          key: args?.state,
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err?.message || "An error occurred");
  }
};

export default {
  getByKey,
  getByGroup,
  create,
  update,
  remove,
};
